/**
 * The warning triangle, drawn rather than typed.
 *
 * U+26A0 has EMOJI presentation by default and Chrome renders it as a colour pictograph — a yellow
 * sign that ignores its inherited ink and sits at whatever size the emoji font decides. This app
 * bans emoji outright, and every place the KANON writes `⚠` is a place where the mark must take the
 * status ink beside it: `--danger-text-strong` on a missed card, the warn ink on the panel's late
 * rule. `currentColor` is what makes that true.
 *
 * Always `aria-hidden`: what it marks is already in the accessible name of whatever carries it, and
 * a screen reader announcing "warning sign" beside the word "skipped" says the same thing twice.
 * Size comes from the caller's stylesheet — the SVG carries no dimensions of its own.
 */

interface WarningGlyphProps {
  /** The caller's class. Sets the box; the paint follows `currentColor`. */
  className?: string;
}

export function WarningGlyph({ className }: WarningGlyphProps) {
  return (
    <svg className={className} viewBox="0 0 10 9" aria-hidden="true" focusable="false">
      <path
        d="M5 0.6 9.3 8.4H0.7Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
      <path d="M5 3.4v2.1" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
      <circle cx="5" cy="6.9" r="0.6" fill="currentColor" />
    </svg>
  );
}
